'use client';

import { useCallback, useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

import { forceTrackPage } from '@monoimin/utils/analytics';
import { loadScript } from '@monoimin/utils/helpers';
import { isProductionEnv } from 'libs/utils/src/lib/envUtils';

const CONFIG = {
  ANALYTICS_SCRIPT_URL: '/scripts/renta.js',
  TIMEOUTS: {
    PAGE_TRACK: 700,
    ANALYTICS_LOAD: 2000,
  },
} as const;

export const ClientAnalytics = () => {
  const isProduction = isProductionEnv();
  const pathname = usePathname();
  const loadedScripts = useRef(new Set<string>());

  const trackPage = useCallback(() => {
    if (!isProduction) return;

    const isArticle = document.querySelector('#___article-page');

    if (!isArticle) {
      forceTrackPage({ action: 'Page' });
    }
  }, [isProduction]);

  const loadAnalytics = useCallback(() => {
    if (window.renta || loadedScripts.current.has('renta-init')) return;

    loadedScripts.current.add('renta-init');
    loadScript({
      src: CONFIG.ANALYTICS_SCRIPT_URL,
      id: 'renta-backup',
      onLoad: () => {
        if (window.renta) {
          trackPage();
        }
      },
    });
  }, [trackPage]);

  useEffect(() => {
    if (!pathname || !isProduction) return;

    const pageTrackTimeout = setTimeout(trackPage, CONFIG.TIMEOUTS.PAGE_TRACK);
    const analyticsLoadTimeout = setTimeout(
      loadAnalytics,
      CONFIG.TIMEOUTS.ANALYTICS_LOAD
    );

    return () => {
      clearTimeout(pageTrackTimeout);
      clearTimeout(analyticsLoadTimeout);
    };
  }, [pathname, trackPage, loadAnalytics, isProduction]);

  return null;
};
